import React, { useState } from 'react';
import { Button, Stack } from '@mui/material';

import { Loader } from 'components/Loader';
import { DeleteConfirmModal } from 'features/procurementSetup/components/DeleteConfirmModal';
import { useDraftNotifications } from '../api/getDraftNotifications';
import { useDeleteNotification } from '../api/deleteNotification';
import { formatDate } from '../utils/formatDate';
import { NotificationFormModal } from './NotificationFormModal';
import { PagedList, usePaging } from './PagedList';
import { QnaCard, QnaEmpty, QnaEntry } from './QnaCard';
import { QnaFiles } from './QnaFiles';

const preview = (text) => (text.length > 40 ? `${text.slice(0, 40)}…` : text);

export const DraftNotificationsList = ({ resource, id }) => {
  const paging = usePaging();
  const { data, isLoading, isError } = useDraftNotifications(resource, id, paging);
  const [editing, setEditing] = useState(null);
  const [deleting, setDeleting] = useState(null);
  const { mutate: deleteNotification } = useDeleteNotification(resource, id, () =>
    setDeleting(null)
  );

  if (isLoading) return <Loader />;
  if (isError)
    return (
      <QnaEmpty title="Something went wrong" message="Draft notifications could not be loaded" />
    );
  if (!data?.total) {
    return (
      <QnaEmpty
        title="No draft notifications"
        message="Notifications saved as drafts will show here"
      />
    );
  }

  return (
    <PagedList paging={paging} total={data.total} sortLabel="Sorted by last saved">
      {data.items.map((notification) => (
        <QnaCard
          key={notification.notification_id}
          title="Draft notification"
          actions={
            <Stack direction="row" gap={1}>
              <Button size="small" variant="outlined" onClick={() => setDeleting(notification)}>
                Delete
              </Button>
              <Button size="small" variant="contained" onClick={() => setEditing(notification)}>
                Edit
              </Button>
            </Stack>
          }
        >
          <QnaEntry
            heading={`Draft saved ${formatDate(notification.edited_on)}`}
            author={notification.created_by_name}
            text={notification.text}
          />
          <QnaFiles resource={resource} id={id} files={notification.files} />
        </QnaCard>
      ))}

      <NotificationFormModal
        resource={resource}
        id={id}
        notification={editing}
        open={!!editing}
        handleClose={() => setEditing(null)}
      />
      <DeleteConfirmModal
        title="Delete draft notification"
        label="draft notification"
        name={deleting ? preview(deleting.text) : ''}
        open={!!deleting}
        handleClose={() => setDeleting(null)}
        onConfirm={() => deleteNotification(deleting.notification_id)}
      />
    </PagedList>
  );
};
